import script from "./Subt.vue?vue&type=script&setup=true&lang=ts"
export * from "./Subt.vue?vue&type=script&setup=true&lang=ts"

import "./Subt.vue?vue&type=style&index=0&id=006a08e2&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006a08e2"]])

export default __exports__